import { useCallback, useEffect, useMemo, useRef } from 'react';
import { debounce, sanitizeSearch } from '@beef/utils';
import { EKeyCodes } from '@carnica/utils/types';
import { selectCorrection, selectQuery, selectSearchResultsPageUrl } from "../../../../../store/slices/search/selectors";
import { useAppSelector } from "../../../../../store/hooks";
import { decorateHandler } from "../../../../../metric";
import { getSearchPageUrl } from "../../../utils/getSearchPageUrl";
export var useInputQuery = function useInputQuery(_ref) {
  var onSearch = _ref.onSearch,
    onChange = _ref.onChange;
  var query = useAppSelector(selectQuery);
  var correction = useAppSelector(selectCorrection);
  var urlSearchResultsPage = useAppSelector(selectSearchResultsPageUrl);
  var ref = useRef(null);
  useEffect(function () {
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(query);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var onSearchDebounce = useMemo(function () {
    return debounce(500, function (args) {
      decorateHandler(function () {
        return onSearch === null || onSearch === void 0 ? void 0 : onSearch(args);
      }, {
        headerMetric: ['handleChangeSearch']
      })();
    });
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  var handleChange = useCallback(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var pureValue = sanitizeSearch(value);
    var isError = !pureValue && value || pureValue === query;
    onChange === null || onChange === void 0 ? void 0 : onChange(pureValue);
    if (!isError) {
      onSearchDebounce(pureValue);
    }
  }, [query] // eslint-disable-line react-hooks/exhaustive-deps
  );

  var handleClear = useCallback(function () {
    var _ref$current;
    onChange === null || onChange === void 0 ? void 0 : onChange('');
    onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleKeyDown = useCallback(function (e) {
    var valueSearch = correction || query;
    if (valueSearch && e.key === EKeyCodes.Enter) {
      window.location.assign(getSearchPageUrl({
        url: urlSearchResultsPage,
        query: valueSearch
      }));
    }
  }, [query, correction] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return useMemo(function () {
    return {
      query: query,
      ref: ref,
      handleChange: handleChange,
      handleClear: handleClear,
      handleKeyDown: handleKeyDown
    };
  }, [query, ref, handleChange, handleClear, handleKeyDown]);
};